import {DG_axios} from "../../custom/axios";


const baseURL = `/o/dogoo/weighing-station`
export async function getAllWeighingStations(page, pageSize,search) {


    const response = await DG_axios.get(baseURL + "/get-list", {
            params: {
                page,
                pageSize,
                search
            }
        }
    )
    return response?.data.result || []
}

export async function getListWeighingStations() {


    const response = await DG_axios.get(baseURL + "/get-list-weighing-station" )
    return response?.data.result || []
}

export async function getWeighingStationById(id) {
    const response = await DG_axios.get(baseURL + "/get/" + id)
    return response?.data.result || []
}
export async function updateWeighingStation(id, data) {
    const response = await DG_axios.put(baseURL + "/update/" + id, data)
    return response?.data.result || []
}

export async function deleteWeighingStation(id) {
    const response = await DG_axios.delete(baseURL + "/delete/" + id)
    return response?.data.result || []
}
export async function addWeighingStation(data) {
    const response = await DG_axios.post(baseURL + "/add" , data)
    return response?.data.result || []
}
export async function getAutocodeWeighingStation(name) {
    const response = await DG_axios.get(baseURL + "/get-auto-code" , {
        params: {
            name
        }
    })
    return response?.data.result || []
}

export async function changeStatusWeighingStation(id, data) {
    const response = await DG_axios.put(baseURL + "/change-status/" + id, data)
    return response?.data.result || []
}
